import React, { type FunctionComponent, useMemo } from 'react'
import { AuthServiceCallback } from 'domains/public/components/auth-service/AuthServiceCallback'
import { PublicLogIn } from 'domains/public/components/log-in/PublicLogIn'
import { PublicCreateAccount } from 'domains/public/components/create-account/PublicCreateAccount'
import { DashSwitch } from 'legacy/dash-components/dash-switch/DashSwitch'
import { DashRoute } from 'legacy/dash-components/dash-route/DashRoute'
import { DashRedirect } from 'legacy/dash-components/dash-redirect/DashRedirect'
import { PublicEmailVerification } from 'domains/public/components/email-verification/PublicEmailVerification'
import { PublicPendingEmailVerification } from 'domains/public/components/pending-email-verification/PublicPendingEmailVerification'
import { PublicRequestEmailVerification } from 'domains/public/components/request-email-verification/PublicRequestEmailVerification'
import { PublicCompleteAccountSetup } from 'domains/public/components/complete-account-setup/PublicCompleteAccountSetup'
import { PublicRequestPasswordReset } from 'domains/public/components/request-password-reset/PublicRequestPasswordReset'
import { PublicPasswordReset } from 'domains/public/components/password-reset/PublicPasswordReset'
import { PublicPendingPasswordReset } from 'domains/public/components/pending-password-reset/PublicPendingPasswordReset'
import { PublicRequestAccountSetup } from 'domains/public/components/request-account-setup/PublicRequestAccountSetup'
import { useCoreContext } from 'utils/core/RPPCoreContext'

export const PublicSection: FunctionComponent = () => {
  const coreContext = useCoreContext()
  const publicRouters = useMemo(
    () => coreContext.publicRouters.map(el => React.cloneElement(el, { key: el.props.route })),
    [coreContext]
  )

  return (
    <DashSwitch>
      <DashRoute route="public-log-in" component={PublicLogIn} />
      <DashRoute route="public-create-account" component={PublicCreateAccount} />

      <DashRoute route="public-email-verification" component={PublicEmailVerification} />
      <DashRoute
        route="public-request-email-verification"
        component={PublicRequestEmailVerification}
      />
      <DashRoute
        route="public-pending-email-verification"
        component={PublicPendingEmailVerification}
      />

      <DashRoute route="public-password-reset" component={PublicPasswordReset} />
      <DashRoute route="public-request-password-reset" component={PublicRequestPasswordReset} />
      <DashRoute route="public-pending-password-reset" component={PublicPendingPasswordReset} />

      <DashRoute route="public-complete-account-setup" component={PublicCompleteAccountSetup} />

      <DashRoute exact route="public-request-account-setup" component={PublicRequestAccountSetup} />

      <DashRoute route="public-auth-service-callback" component={AuthServiceCallback} />

      {publicRouters}

      <DashRedirect toRoute="public-log-in" />
    </DashSwitch>
  )
}
